"use strict";

exports.__esModule = true;
exports.STAFF_RESOURCE_GROUP_ID = exports.SEPARATOR = exports.DO_NOT_CARE_STAFF = void 0;
const STAFF_RESOURCE_GROUP_ID = exports.STAFF_RESOURCE_GROUP_ID = 'staff';
const SEPARATOR = exports.SEPARATOR = ' • ';
const DO_NOT_CARE_STAFF = exports.DO_NOT_CARE_STAFF = 'DO_NOT_CARE';
//# sourceMappingURL=constants.js.map